import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { PatientRegistrationCenterStore } from './patient-registration-center.store';
import { PatientRegistrationData } from './patient-registration-center.resolver';

@Component({
  selector: 'app-patient-registration-center',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MatTabsModule, MatIconModule],
  providers: [PatientRegistrationCenterStore],
  templateUrl: './patient-registration-center.component.html',
  styleUrls: ['./patient-registration-center.component.scss']
})
export class PatientRegistrationCenterComponent implements OnInit {
  router = inject(Router);
  route = inject(ActivatedRoute);
  store = inject(PatientRegistrationCenterStore);
  destroyRef = inject(DestroyRef);

  selectedTabIndex = 0;
  pendingCount = 0;
  approvedCount = 0;
  deceasedCount = 0;

  private readonly tabRoutes = ['pending', 'approved', 'archived', 'deceased'];


  ngOnInit() {
    // Load initial data from route resolver - CORRECTED TYPE
    const resolverData = this.route.snapshot.data['patientCenter'] as PatientRegistrationData | undefined;

    // Use the correct method for PatientRegistrationData
    if (resolverData) {
      this.store.setFromResolverData(resolverData);
    }

    // Subscribe to counts
    this.store.pending$.subscribe(pending => {
      this.pendingCount = pending.length;
    });

    this.store.approved$.subscribe(approved => {
      this.approvedCount = approved.length;
    });

    this.store.deceased$.subscribe(deceased => {
      this.deceasedCount = deceased.length;
    });

        // Set initial tab based on current route
    const updateSelectedTab = () => {
      let currentPath = '';
      if (this.route.firstChild) {
        currentPath = this.route.firstChild.snapshot.routeConfig?.path || '';
      } else {
        // Fallback for getting the leaf route path
        const urlParts = this.router.url.split('/');
        currentPath = urlParts[urlParts.length - 1].split('?')[0];
      }
      const idx = this.tabRoutes.indexOf(currentPath);
      if (idx !== -1) {
        this.selectedTabIndex = idx;
      }
    };

    updateSelectedTab();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      updateSelectedTab();
    });
  }

  onTabChange(index: number): void {
    const route = this.tabRoutes[index];
    if (route) {
      this.router.navigate([route], { relativeTo: this.route });
    }
  }
}

